// generated with @7nohe/openapi-react-query-codegen@1.6.1

import type { UseQueryResult } from '@tanstack/react-query'

import type {
  AdminCompaniesService,
  AdminStatsService,
  AdminUsersService,
  AdminWhitelistService,
  AdvisorsAppointmentsService,
  AdvisorService,
  AdvisorsService,
  AppointmentsService,
  BankingService,
  BudgetService,
  EmailNotificationsService,
  EmailPreviewService,
  EmployerAdvisorsService,
  EmployerStatsService,
  EmployerUsersService,
  FileService,
  GoalsService,
  InsightsService,
  MessageService,
  NotificationsService,
  OnboardingService,
  QueueService,
  RolanWealthService,
  SupportService,
  TransactionService,
  UserService,
} from '../requests/services.gen'

export type UserServiceUserControllerGetLoggedUserDefaultResponse = Awaited<
  ReturnType<typeof UserService.userControllerGetLoggedUser>
>
export type UserServiceUserControllerGetLoggedUserQueryResult<
  TData = UserServiceUserControllerGetLoggedUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useUserServiceUserControllerGetLoggedUserKey =
  'UserServiceUserControllerGetLoggedUser'
export const UseUserServiceUserControllerGetLoggedUserKeyFn = (
  queryKey?: Array<unknown>,
) => [useUserServiceUserControllerGetLoggedUserKey, ...(queryKey ?? [])]
export type MessageServiceMessageControllerGetAllMessagesDefaultResponse =
  Awaited<ReturnType<typeof MessageService.messageControllerGetAllMessages>>
export type MessageServiceMessageControllerGetAllMessagesQueryResult<
  TData = MessageServiceMessageControllerGetAllMessagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useMessageServiceMessageControllerGetAllMessagesKey =
  'MessageServiceMessageControllerGetAllMessages'
export const UseMessageServiceMessageControllerGetAllMessagesKeyFn = (
  {
    recipientId,
    skip,
    take,
  }: {
    recipientId: number
    skip: number
    take: number
  },
  queryKey?: Array<unknown>,
) => [
  useMessageServiceMessageControllerGetAllMessagesKey,
  ...(queryKey ?? [{ recipientId, skip, take }]),
]
export type QueueServiceQueueControllerProcessJobsDefaultResponse = Awaited<
  ReturnType<typeof QueueService.queueControllerProcessJobs>
>
export type QueueServiceQueueControllerProcessJobsQueryResult<
  TData = QueueServiceQueueControllerProcessJobsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useQueueServiceQueueControllerProcessJobsKey =
  'QueueServiceQueueControllerProcessJobs'
export const UseQueueServiceQueueControllerProcessJobsKeyFn = (
  queryKey?: Array<unknown>,
) => [useQueueServiceQueueControllerProcessJobsKey, ...(queryKey ?? [])]
export type QueueServiceQueueControllerSyncTransactionsDefaultResponse =
  Awaited<ReturnType<typeof QueueService.queueControllerSyncTransactions>>
export type QueueServiceQueueControllerSyncTransactionsQueryResult<
  TData = QueueServiceQueueControllerSyncTransactionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useQueueServiceQueueControllerSyncTransactionsKey =
  'QueueServiceQueueControllerSyncTransactions'
export const UseQueueServiceQueueControllerSyncTransactionsKeyFn = (
  queryKey?: Array<unknown>,
) => [useQueueServiceQueueControllerSyncTransactionsKey, ...(queryKey ?? [])]
export type QueueServiceQueueControllerMonthlyJobsDefaultResponse = Awaited<
  ReturnType<typeof QueueService.queueControllerMonthlyJobs>
>
export type QueueServiceQueueControllerMonthlyJobsQueryResult<
  TData = QueueServiceQueueControllerMonthlyJobsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useQueueServiceQueueControllerMonthlyJobsKey =
  'QueueServiceQueueControllerMonthlyJobs'
export const UseQueueServiceQueueControllerMonthlyJobsKeyFn = (
  queryKey?: Array<unknown>,
) => [useQueueServiceQueueControllerMonthlyJobsKey, ...(queryKey ?? [])]
export type TransactionServiceTransactionControllerGetTransactionsDefaultResponse =
  Awaited<
    ReturnType<typeof TransactionService.transactionControllerGetTransactions>
  >
export type TransactionServiceTransactionControllerGetTransactionsQueryResult<
  TData = TransactionServiceTransactionControllerGetTransactionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useTransactionServiceTransactionControllerGetTransactionsKey =
  'TransactionServiceTransactionControllerGetTransactions'
export const UseTransactionServiceTransactionControllerGetTransactionsKeyFn = (
  {
    endDate,
    startDate,
    type,
  }: {
    endDate: string
    startDate: string
    type: 'income' | 'spending'
  },
  queryKey?: Array<unknown>,
) => [
  useTransactionServiceTransactionControllerGetTransactionsKey,
  ...(queryKey ?? [{ endDate, startDate, type }]),
]
export type BankingServiceBankingControllerGetManualAccountDefaultResponse =
  Awaited<ReturnType<typeof BankingService.bankingControllerGetManualAccount>>
export type BankingServiceBankingControllerGetManualAccountQueryResult<
  TData = BankingServiceBankingControllerGetManualAccountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetManualAccountKey =
  'BankingServiceBankingControllerGetManualAccount'
export const UseBankingServiceBankingControllerGetManualAccountKeyFn = (
  {
    accountId,
  }: {
    accountId: string
  },
  queryKey?: Array<unknown>,
) => [
  useBankingServiceBankingControllerGetManualAccountKey,
  ...(queryKey ?? [{ accountId }]),
]
export type BankingServiceBankingControllerGetAccountsDefaultResponse = Awaited<
  ReturnType<typeof BankingService.bankingControllerGetAccounts>
>
export type BankingServiceBankingControllerGetAccountsQueryResult<
  TData = BankingServiceBankingControllerGetAccountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetAccountsKey =
  'BankingServiceBankingControllerGetAccounts'
export const UseBankingServiceBankingControllerGetAccountsKeyFn = (
  queryKey?: Array<unknown>,
) => [useBankingServiceBankingControllerGetAccountsKey, ...(queryKey ?? [])]
export type BankingServiceBankingControllerGetManualAccountsDefaultResponse =
  Awaited<ReturnType<typeof BankingService.bankingControllerGetManualAccounts>>
export type BankingServiceBankingControllerGetManualAccountsQueryResult<
  TData = BankingServiceBankingControllerGetManualAccountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetManualAccountsKey =
  'BankingServiceBankingControllerGetManualAccounts'
export const UseBankingServiceBankingControllerGetManualAccountsKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useBankingServiceBankingControllerGetManualAccountsKey,
  ...(queryKey ?? []),
]
export type BankingServiceBankingControllerWebhookDefaultResponse = Awaited<
  ReturnType<typeof BankingService.bankingControllerWebhook>
>
export type BankingServiceBankingControllerWebhookQueryResult<
  TData = BankingServiceBankingControllerWebhookDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerWebhookKey =
  'BankingServiceBankingControllerWebhook'
export const UseBankingServiceBankingControllerWebhookKeyFn = (
  queryKey?: Array<unknown>,
) => [useBankingServiceBankingControllerWebhookKey, ...(queryKey ?? [])]
export type BankingServiceBankingControllerGetLinearStatsDefaultResponse =
  Awaited<ReturnType<typeof BankingService.bankingControllerGetLinearStats>>
export type BankingServiceBankingControllerGetLinearStatsQueryResult<
  TData = BankingServiceBankingControllerGetLinearStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetLinearStatsKey =
  'BankingServiceBankingControllerGetLinearStats'
export const UseBankingServiceBankingControllerGetLinearStatsKeyFn = (
  {
    period,
    type,
  }: {
    period: 'half-year' | 'month' | 'quarter' | 'year'
    type: 'assets' | 'debt' | 'net-worth'
  },
  queryKey?: Array<unknown>,
) => [
  useBankingServiceBankingControllerGetLinearStatsKey,
  ...(queryKey ?? [{ period, type }]),
]
export type BankingServiceBankingControllerGetDonutStatsDefaultResponse =
  Awaited<ReturnType<typeof BankingService.bankingControllerGetDonutStats>>
export type BankingServiceBankingControllerGetDonutStatsQueryResult<
  TData = BankingServiceBankingControllerGetDonutStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetDonutStatsKey =
  'BankingServiceBankingControllerGetDonutStats'
export const UseBankingServiceBankingControllerGetDonutStatsKeyFn = (
  {
    type,
  }: {
    type: 'assets' | 'debt' | 'net-worth'
  },
  queryKey?: Array<unknown>,
) => [
  useBankingServiceBankingControllerGetDonutStatsKey,
  ...(queryKey ?? [{ type }]),
]
export type BankingServiceBankingControllerGetIncomeStatsDefaultResponse =
  Awaited<ReturnType<typeof BankingService.bankingControllerGetIncomeStats>>
export type BankingServiceBankingControllerGetIncomeStatsQueryResult<
  TData = BankingServiceBankingControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetIncomeStatsKey =
  'BankingServiceBankingControllerGetIncomeStats'
export const UseBankingServiceBankingControllerGetIncomeStatsKeyFn = (
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: Array<unknown>,
) => [
  useBankingServiceBankingControllerGetIncomeStatsKey,
  ...(queryKey ?? [{ endDate, startDate }]),
]
export type BankingServiceBankingControllerGetSpendingStatsDefaultResponse =
  Awaited<ReturnType<typeof BankingService.bankingControllerGetSpendingStats>>
export type BankingServiceBankingControllerGetSpendingStatsQueryResult<
  TData = BankingServiceBankingControllerGetSpendingStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBankingServiceBankingControllerGetSpendingStatsKey =
  'BankingServiceBankingControllerGetSpendingStats'
export const UseBankingServiceBankingControllerGetSpendingStatsKeyFn = (
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: Array<unknown>,
) => [
  useBankingServiceBankingControllerGetSpendingStatsKey,
  ...(queryKey ?? [{ endDate, startDate }]),
]
export type GoalsServiceGoalsControllerGetDefaultResponse = Awaited<
  ReturnType<typeof GoalsService.goalsControllerGet>
>
export type GoalsServiceGoalsControllerGetQueryResult<
  TData = GoalsServiceGoalsControllerGetDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useGoalsServiceGoalsControllerGetKey =
  'GoalsServiceGoalsControllerGet'
export const UseGoalsServiceGoalsControllerGetKeyFn = (
  {
    goalId,
  }: {
    goalId: number
  },
  queryKey?: Array<unknown>,
) => [useGoalsServiceGoalsControllerGetKey, ...(queryKey ?? [{ goalId }])]
export type GoalsServiceGoalsControllerGetAllDefaultResponse = Awaited<
  ReturnType<typeof GoalsService.goalsControllerGetAll>
>
export type GoalsServiceGoalsControllerGetAllQueryResult<
  TData = GoalsServiceGoalsControllerGetAllDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useGoalsServiceGoalsControllerGetAllKey =
  'GoalsServiceGoalsControllerGetAll'
export const UseGoalsServiceGoalsControllerGetAllKeyFn = (
  {
    orderBy,
    status,
  }: {
    orderBy: 'deadline' | 'new_first' | 'old_first'
    status?: 'ACTIVE' | 'COMPLETED' | 'ARCHIVED'
  },
  queryKey?: Array<unknown>,
) => [
  useGoalsServiceGoalsControllerGetAllKey,
  ...(queryKey ?? [{ orderBy, status }]),
]
export type GoalsServiceGoalsControllerGetRecommendationsDefaultResponse =
  Awaited<ReturnType<typeof GoalsService.goalsControllerGetRecommendations>>
export type GoalsServiceGoalsControllerGetRecommendationsQueryResult<
  TData = GoalsServiceGoalsControllerGetRecommendationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useGoalsServiceGoalsControllerGetRecommendationsKey =
  'GoalsServiceGoalsControllerGetRecommendations'
export const UseGoalsServiceGoalsControllerGetRecommendationsKeyFn = (
  queryKey?: Array<unknown>,
) => [useGoalsServiceGoalsControllerGetRecommendationsKey, ...(queryKey ?? [])]
export type GoalsServiceGoalsControllerGetSavedValueDefaultResponse = Awaited<
  ReturnType<typeof GoalsService.goalsControllerGetSavedValue>
>
export type GoalsServiceGoalsControllerGetSavedValueQueryResult<
  TData = GoalsServiceGoalsControllerGetSavedValueDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useGoalsServiceGoalsControllerGetSavedValueKey =
  'GoalsServiceGoalsControllerGetSavedValue'
export const UseGoalsServiceGoalsControllerGetSavedValueKeyFn = (
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: Array<unknown>,
) => [
  useGoalsServiceGoalsControllerGetSavedValueKey,
  ...(queryKey ?? [{ endDate, startDate }]),
]
export type GoalsServiceGoalsControllerGetStepsDefaultResponse = Awaited<
  ReturnType<typeof GoalsService.goalsControllerGetSteps>
>
export type GoalsServiceGoalsControllerGetStepsQueryResult<
  TData = GoalsServiceGoalsControllerGetStepsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useGoalsServiceGoalsControllerGetStepsKey =
  'GoalsServiceGoalsControllerGetSteps'
export const UseGoalsServiceGoalsControllerGetStepsKeyFn = (
  {
    goalId,
  }: {
    goalId: number
  },
  queryKey?: Array<unknown>,
) => [useGoalsServiceGoalsControllerGetStepsKey, ...(queryKey ?? [{ goalId }])]
export type NotificationsServiceNotificationControllerGetAllDefaultResponse =
  Awaited<ReturnType<typeof NotificationsService.notificationControllerGetAll>>
export type NotificationsServiceNotificationControllerGetAllQueryResult<
  TData = NotificationsServiceNotificationControllerGetAllDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useNotificationsServiceNotificationControllerGetAllKey =
  'NotificationsServiceNotificationControllerGetAll'
export const UseNotificationsServiceNotificationControllerGetAllKeyFn = (
  {
    action,
    status,
  }: {
    action?: 'CLAIM_MONTHLY_REMINDER'
    status?: 'UNREAD' | 'READ'
  } = {},
  queryKey?: Array<unknown>,
) => [
  useNotificationsServiceNotificationControllerGetAllKey,
  ...(queryKey ?? [{ action, status }]),
]
export type FileServiceFileControllerGetSignedUrlDefaultResponse = Awaited<
  ReturnType<typeof FileService.fileControllerGetSignedUrl>
>
export type FileServiceFileControllerGetSignedUrlQueryResult<
  TData = FileServiceFileControllerGetSignedUrlDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useFileServiceFileControllerGetSignedUrlKey =
  'FileServiceFileControllerGetSignedUrl'
export const UseFileServiceFileControllerGetSignedUrlKeyFn = (
  {
    filename,
  }: {
    filename: string
  },
  queryKey?: Array<unknown>,
) => [
  useFileServiceFileControllerGetSignedUrlKey,
  ...(queryKey ?? [{ filename }]),
]
export type BudgetServiceBudgetControllerGetBudgetDefaultResponse = Awaited<
  ReturnType<typeof BudgetService.budgetControllerGetBudget>
>
export type BudgetServiceBudgetControllerGetBudgetQueryResult<
  TData = BudgetServiceBudgetControllerGetBudgetDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBudgetServiceBudgetControllerGetBudgetKey =
  'BudgetServiceBudgetControllerGetBudget'
export const UseBudgetServiceBudgetControllerGetBudgetKeyFn = (
  {
    budgetId,
  }: {
    budgetId: number
  },
  queryKey?: Array<unknown>,
) => [
  useBudgetServiceBudgetControllerGetBudgetKey,
  ...(queryKey ?? [{ budgetId }]),
]
export type BudgetServiceBudgetControllerGetAllBudgetsDefaultResponse = Awaited<
  ReturnType<typeof BudgetService.budgetControllerGetAllBudgets>
>
export type BudgetServiceBudgetControllerGetAllBudgetsQueryResult<
  TData = BudgetServiceBudgetControllerGetAllBudgetsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useBudgetServiceBudgetControllerGetAllBudgetsKey =
  'BudgetServiceBudgetControllerGetAllBudgets'
export const UseBudgetServiceBudgetControllerGetAllBudgetsKeyFn = (
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: Array<unknown>,
) => [
  useBudgetServiceBudgetControllerGetAllBudgetsKey,
  ...(queryKey ?? [{ endDate, startDate }]),
]
export type OnboardingServiceOnboardingControllerGetAnswersDefaultResponse =
  Awaited<ReturnType<typeof OnboardingService.onboardingControllerGetAnswers>>
export type OnboardingServiceOnboardingControllerGetAnswersQueryResult<
  TData = OnboardingServiceOnboardingControllerGetAnswersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useOnboardingServiceOnboardingControllerGetAnswersKey =
  'OnboardingServiceOnboardingControllerGetAnswers'
export const UseOnboardingServiceOnboardingControllerGetAnswersKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useOnboardingServiceOnboardingControllerGetAnswersKey,
  ...(queryKey ?? []),
]
export type AdvisorServiceAdvisorControllerGetAllAdvisorsDefaultResponse =
  Awaited<ReturnType<typeof AdvisorService.advisorControllerGetAllAdvisors>>
export type AdvisorServiceAdvisorControllerGetAllAdvisorsQueryResult<
  TData = AdvisorServiceAdvisorControllerGetAllAdvisorsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorServiceAdvisorControllerGetAllAdvisorsKey =
  'AdvisorServiceAdvisorControllerGetAllAdvisors'
export const UseAdvisorServiceAdvisorControllerGetAllAdvisorsKeyFn = (
  {
    query,
  }: {
    query?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdvisorServiceAdvisorControllerGetAllAdvisorsKey,
  ...(queryKey ?? [{ query }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetUsersDefaultResponse =
  Awaited<ReturnType<typeof AdvisorsService.advisorUsersControllerGetUsers>>
export type AdvisorsServiceAdvisorUsersControllerGetUsersQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetUsersKey =
  'AdvisorsServiceAdvisorUsersControllerGetUsers'
export const UseAdvisorsServiceAdvisorUsersControllerGetUsersKeyFn = (
  queryKey?: Array<unknown>,
) => [useAdvisorsServiceAdvisorUsersControllerGetUsersKey, ...(queryKey ?? [])]
export type AdvisorsServiceAdvisorUsersControllerGetUserByIdDefaultResponse =
  Awaited<ReturnType<typeof AdvisorsService.advisorUsersControllerGetUserById>>
export type AdvisorsServiceAdvisorUsersControllerGetUserByIdQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetUserByIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetUserByIdKey =
  'AdvisorsServiceAdvisorUsersControllerGetUserById'
export const UseAdvisorsServiceAdvisorUsersControllerGetUserByIdKeyFn = (
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetUserByIdKey,
  ...(queryKey ?? [{ userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetChatUsersDefaultResponse =
  Awaited<ReturnType<typeof AdvisorsService.advisorUsersControllerGetChatUsers>>
export type AdvisorsServiceAdvisorUsersControllerGetChatUsersQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetChatUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetChatUsersKey =
  'AdvisorsServiceAdvisorUsersControllerGetChatUsers'
export const UseAdvisorsServiceAdvisorUsersControllerGetChatUsersKeyFn = (
  {
    query,
  }: {
    query?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetChatUsersKey,
  ...(queryKey ?? [{ query }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireDefaultResponse =
  Awaited<
    ReturnType<
      typeof AdvisorsService.advisorUsersControllerGetUserQuestionnaire
    >
  >
export type AdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireKey =
  'AdvisorsServiceAdvisorUsersControllerGetUserQuestionnaire'
export const UseAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireKeyFn =
  (
    {
      userId,
    }: {
      userId: number
    },
    queryKey?: Array<unknown>,
  ) => [
    useAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireKey,
    ...(queryKey ?? [{ userId }]),
  ]
export type AdvisorsServiceAdvisorUsersControllerGetDonutStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdvisorsService.advisorUsersControllerGetDonutStats>
  >
export type AdvisorsServiceAdvisorUsersControllerGetDonutStatsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetDonutStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetDonutStatsKey =
  'AdvisorsServiceAdvisorUsersControllerGetDonutStats'
export const UseAdvisorsServiceAdvisorUsersControllerGetDonutStatsKeyFn = (
  {
    type,
    userId,
  }: {
    type: 'assets' | 'debt' | 'net-worth'
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetDonutStatsKey,
  ...(queryKey ?? [{ type, userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetIncomeStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdvisorsService.advisorUsersControllerGetIncomeStats>
  >
export type AdvisorsServiceAdvisorUsersControllerGetIncomeStatsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetIncomeStatsKey =
  'AdvisorsServiceAdvisorUsersControllerGetIncomeStats'
export const UseAdvisorsServiceAdvisorUsersControllerGetIncomeStatsKeyFn = (
  {
    endDate,
    startDate,
    userId,
  }: {
    endDate: string
    startDate: string
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetIncomeStatsKey,
  ...(queryKey ?? [{ endDate, startDate, userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetSpendingStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdvisorsService.advisorUsersControllerGetSpendingStats>
  >
export type AdvisorsServiceAdvisorUsersControllerGetSpendingStatsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetSpendingStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetSpendingStatsKey =
  'AdvisorsServiceAdvisorUsersControllerGetSpendingStats'
export const UseAdvisorsServiceAdvisorUsersControllerGetSpendingStatsKeyFn = (
  {
    endDate,
    startDate,
    userId,
  }: {
    endDate: string
    startDate: string
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetSpendingStatsKey,
  ...(queryKey ?? [{ endDate, startDate, userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetLinearStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdvisorsService.advisorUsersControllerGetLinearStats>
  >
export type AdvisorsServiceAdvisorUsersControllerGetLinearStatsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetLinearStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetLinearStatsKey =
  'AdvisorsServiceAdvisorUsersControllerGetLinearStats'
export const UseAdvisorsServiceAdvisorUsersControllerGetLinearStatsKeyFn = (
  {
    period,
    type,
    userId,
  }: {
    period: 'half-year' | 'month' | 'quarter' | 'year'
    type: 'assets' | 'debt' | 'net-worth'
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetLinearStatsKey,
  ...(queryKey ?? [{ period, type, userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetBudgetsDefaultResponse =
  Awaited<ReturnType<typeof AdvisorsService.advisorUsersControllerGetBudgets>>
export type AdvisorsServiceAdvisorUsersControllerGetBudgetsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetBudgetsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetBudgetsKey =
  'AdvisorsServiceAdvisorUsersControllerGetBudgets'
export const UseAdvisorsServiceAdvisorUsersControllerGetBudgetsKeyFn = (
  {
    endDate,
    startDate,
    userId,
  }: {
    endDate: string
    startDate: string
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetBudgetsKey,
  ...(queryKey ?? [{ endDate, startDate, userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetGoalsDefaultResponse =
  Awaited<ReturnType<typeof AdvisorsService.advisorUsersControllerGetGoals>>
export type AdvisorsServiceAdvisorUsersControllerGetGoalsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetGoalsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetGoalsKey =
  'AdvisorsServiceAdvisorUsersControllerGetGoals'
export const UseAdvisorsServiceAdvisorUsersControllerGetGoalsKeyFn = (
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetGoalsKey,
  ...(queryKey ?? [{ userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetAccountsDefaultResponse =
  Awaited<ReturnType<typeof AdvisorsService.advisorUsersControllerGetAccounts>>
export type AdvisorsServiceAdvisorUsersControllerGetAccountsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetAccountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetAccountsKey =
  'AdvisorsServiceAdvisorUsersControllerGetAccounts'
export const UseAdvisorsServiceAdvisorUsersControllerGetAccountsKeyFn = (
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetAccountsKey,
  ...(queryKey ?? [{ userId }]),
]
export type AdvisorsServiceAdvisorUsersControllerGetTransactionsDefaultResponse =
  Awaited<
    ReturnType<typeof AdvisorsService.advisorUsersControllerGetTransactions>
  >
export type AdvisorsServiceAdvisorUsersControllerGetTransactionsQueryResult<
  TData = AdvisorsServiceAdvisorUsersControllerGetTransactionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsServiceAdvisorUsersControllerGetTransactionsKey =
  'AdvisorsServiceAdvisorUsersControllerGetTransactions'
export const UseAdvisorsServiceAdvisorUsersControllerGetTransactionsKeyFn = (
  {
    endDate,
    startDate,
    type,
    userId,
  }: {
    endDate: string
    startDate: string
    type: 'income' | 'spending'
    userId: number
  },
  queryKey?: Array<unknown>,
) => [
  useAdvisorsServiceAdvisorUsersControllerGetTransactionsKey,
  ...(queryKey ?? [{ endDate, startDate, type, userId }]),
]
export type AdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AdvisorsAppointmentsService.advisorAppointmentsControllerGetAllAppointments
    >
  >
export type AdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsQueryResult<
  TData = AdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsKey =
  'AdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointments'
export const UseAdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsKeyFn =
  (
    {
      limit,
      sort,
      userId,
    }: {
      limit?: number
      sort?: unknown
      userId?: number
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsKey,
    ...(queryKey ?? [{ limit, sort, userId }]),
  ]
export type AdminStatsServiceAdminStatsControllerGetUserStatsDefaultResponse =
  Awaited<ReturnType<typeof AdminStatsService.adminStatsControllerGetUserStats>>
export type AdminStatsServiceAdminStatsControllerGetUserStatsQueryResult<
  TData = AdminStatsServiceAdminStatsControllerGetUserStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminStatsServiceAdminStatsControllerGetUserStatsKey =
  'AdminStatsServiceAdminStatsControllerGetUserStats'
export const UseAdminStatsServiceAdminStatsControllerGetUserStatsKeyFn = (
  {
    company,
    endDate,
    startDate,
  }: {
    company?: string
    endDate: string
    startDate: string
  },
  queryKey?: Array<unknown>,
) => [
  useAdminStatsServiceAdminStatsControllerGetUserStatsKey,
  ...(queryKey ?? [{ company, endDate, startDate }]),
]
export type AdminStatsServiceAdminStatsControllerGetGenderStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdminStatsService.adminStatsControllerGetGenderStats>
  >
export type AdminStatsServiceAdminStatsControllerGetGenderStatsQueryResult<
  TData = AdminStatsServiceAdminStatsControllerGetGenderStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminStatsServiceAdminStatsControllerGetGenderStatsKey =
  'AdminStatsServiceAdminStatsControllerGetGenderStats'
export const UseAdminStatsServiceAdminStatsControllerGetGenderStatsKeyFn = (
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdminStatsServiceAdminStatsControllerGetGenderStatsKey,
  ...(queryKey ?? [{ company }]),
]
export type AdminStatsServiceAdminStatsControllerGetRaceStatsDefaultResponse =
  Awaited<ReturnType<typeof AdminStatsService.adminStatsControllerGetRaceStats>>
export type AdminStatsServiceAdminStatsControllerGetRaceStatsQueryResult<
  TData = AdminStatsServiceAdminStatsControllerGetRaceStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminStatsServiceAdminStatsControllerGetRaceStatsKey =
  'AdminStatsServiceAdminStatsControllerGetRaceStats'
export const UseAdminStatsServiceAdminStatsControllerGetRaceStatsKeyFn = (
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdminStatsServiceAdminStatsControllerGetRaceStatsKey,
  ...(queryKey ?? [{ company }]),
]
export type AdminStatsServiceAdminStatsControllerGetAgeStatsDefaultResponse =
  Awaited<ReturnType<typeof AdminStatsService.adminStatsControllerGetAgeStats>>
export type AdminStatsServiceAdminStatsControllerGetAgeStatsQueryResult<
  TData = AdminStatsServiceAdminStatsControllerGetAgeStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminStatsServiceAdminStatsControllerGetAgeStatsKey =
  'AdminStatsServiceAdminStatsControllerGetAgeStats'
export const UseAdminStatsServiceAdminStatsControllerGetAgeStatsKeyFn = (
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdminStatsServiceAdminStatsControllerGetAgeStatsKey,
  ...(queryKey ?? [{ company }]),
]
export type AdminStatsServiceAdminStatsControllerGetIncomeStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdminStatsService.adminStatsControllerGetIncomeStats>
  >
export type AdminStatsServiceAdminStatsControllerGetIncomeStatsQueryResult<
  TData = AdminStatsServiceAdminStatsControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminStatsServiceAdminStatsControllerGetIncomeStatsKey =
  'AdminStatsServiceAdminStatsControllerGetIncomeStats'
export const UseAdminStatsServiceAdminStatsControllerGetIncomeStatsKeyFn = (
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdminStatsServiceAdminStatsControllerGetIncomeStatsKey,
  ...(queryKey ?? [{ company }]),
]
export type AdminStatsServiceAdminStatsControllerGetTopicsStatsDefaultResponse =
  Awaited<
    ReturnType<typeof AdminStatsService.adminStatsControllerGetTopicsStats>
  >
export type AdminStatsServiceAdminStatsControllerGetTopicsStatsQueryResult<
  TData = AdminStatsServiceAdminStatsControllerGetTopicsStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminStatsServiceAdminStatsControllerGetTopicsStatsKey =
  'AdminStatsServiceAdminStatsControllerGetTopicsStats'
export const UseAdminStatsServiceAdminStatsControllerGetTopicsStatsKeyFn = (
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdminStatsServiceAdminStatsControllerGetTopicsStatsKey,
  ...(queryKey ?? [{ company }]),
]
export type AdminCompaniesServiceAdminCompaniesControllerGetCompaniesDefaultResponse =
  Awaited<
    ReturnType<
      typeof AdminCompaniesService.adminCompaniesControllerGetCompanies
    >
  >
export type AdminCompaniesServiceAdminCompaniesControllerGetCompaniesQueryResult<
  TData = AdminCompaniesServiceAdminCompaniesControllerGetCompaniesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAdminCompaniesServiceAdminCompaniesControllerGetCompaniesKey =
  'AdminCompaniesServiceAdminCompaniesControllerGetCompanies'
export const UseAdminCompaniesServiceAdminCompaniesControllerGetCompaniesKeyFn =
  (queryKey?: Array<unknown>) => [
    useAdminCompaniesServiceAdminCompaniesControllerGetCompaniesKey,
    ...(queryKey ?? []),
  ]
export type EmployerStatsServiceEmployerStatsControllerGetUserStatsDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerStatsService.employerStatsControllerGetUserStats>
  >
export type EmployerStatsServiceEmployerStatsControllerGetUserStatsQueryResult<
  TData = EmployerStatsServiceEmployerStatsControllerGetUserStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerStatsServiceEmployerStatsControllerGetUserStatsKey =
  'EmployerStatsServiceEmployerStatsControllerGetUserStats'
export const UseEmployerStatsServiceEmployerStatsControllerGetUserStatsKeyFn = (
  {
    company,
    endDate,
    startDate,
  }: {
    company?: string
    endDate: string
    startDate: string
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerStatsServiceEmployerStatsControllerGetUserStatsKey,
  ...(queryKey ?? [{ company, endDate, startDate }]),
]
export type EmployerStatsServiceEmployerStatsControllerGetGenderStatsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerStatsService.employerStatsControllerGetGenderStats
    >
  >
export type EmployerStatsServiceEmployerStatsControllerGetGenderStatsQueryResult<
  TData = EmployerStatsServiceEmployerStatsControllerGetGenderStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerStatsServiceEmployerStatsControllerGetGenderStatsKey =
  'EmployerStatsServiceEmployerStatsControllerGetGenderStats'
export const UseEmployerStatsServiceEmployerStatsControllerGetGenderStatsKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmployerStatsServiceEmployerStatsControllerGetGenderStatsKey,
    ...(queryKey ?? []),
  ]
export type EmployerStatsServiceEmployerStatsControllerGetRaceStatsDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerStatsService.employerStatsControllerGetRaceStats>
  >
export type EmployerStatsServiceEmployerStatsControllerGetRaceStatsQueryResult<
  TData = EmployerStatsServiceEmployerStatsControllerGetRaceStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerStatsServiceEmployerStatsControllerGetRaceStatsKey =
  'EmployerStatsServiceEmployerStatsControllerGetRaceStats'
export const UseEmployerStatsServiceEmployerStatsControllerGetRaceStatsKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useEmployerStatsServiceEmployerStatsControllerGetRaceStatsKey,
  ...(queryKey ?? []),
]
export type EmployerStatsServiceEmployerStatsControllerGetAgeStatsDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerStatsService.employerStatsControllerGetAgeStats>
  >
export type EmployerStatsServiceEmployerStatsControllerGetAgeStatsQueryResult<
  TData = EmployerStatsServiceEmployerStatsControllerGetAgeStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerStatsServiceEmployerStatsControllerGetAgeStatsKey =
  'EmployerStatsServiceEmployerStatsControllerGetAgeStats'
export const UseEmployerStatsServiceEmployerStatsControllerGetAgeStatsKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useEmployerStatsServiceEmployerStatsControllerGetAgeStatsKey,
  ...(queryKey ?? []),
]
export type EmployerStatsServiceEmployerStatsControllerGetIncomeStatsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerStatsService.employerStatsControllerGetIncomeStats
    >
  >
export type EmployerStatsServiceEmployerStatsControllerGetIncomeStatsQueryResult<
  TData = EmployerStatsServiceEmployerStatsControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerStatsServiceEmployerStatsControllerGetIncomeStatsKey =
  'EmployerStatsServiceEmployerStatsControllerGetIncomeStats'
export const UseEmployerStatsServiceEmployerStatsControllerGetIncomeStatsKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmployerStatsServiceEmployerStatsControllerGetIncomeStatsKey,
    ...(queryKey ?? []),
  ]
export type EmployerStatsServiceEmployerStatsControllerGetTopicStatsDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerStatsService.employerStatsControllerGetTopicStats>
  >
export type EmployerStatsServiceEmployerStatsControllerGetTopicStatsQueryResult<
  TData = EmployerStatsServiceEmployerStatsControllerGetTopicStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerStatsServiceEmployerStatsControllerGetTopicStatsKey =
  'EmployerStatsServiceEmployerStatsControllerGetTopicStats'
export const UseEmployerStatsServiceEmployerStatsControllerGetTopicStatsKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmployerStatsServiceEmployerStatsControllerGetTopicStatsKey,
    ...(queryKey ?? []),
  ]
export type EmployerUsersServiceEmployerUsersControllerGetAllEmployeesDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerUsersService.employerUsersControllerGetAllEmployees
    >
  >
export type EmployerUsersServiceEmployerUsersControllerGetAllEmployeesQueryResult<
  TData = EmployerUsersServiceEmployerUsersControllerGetAllEmployeesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerUsersServiceEmployerUsersControllerGetAllEmployeesKey =
  'EmployerUsersServiceEmployerUsersControllerGetAllEmployees'
export const UseEmployerUsersServiceEmployerUsersControllerGetAllEmployeesKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmployerUsersServiceEmployerUsersControllerGetAllEmployeesKey,
    ...(queryKey ?? []),
  ]
export type EmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerAdvisorsService.employerAdvisorControllerGetAllAdvisors
    >
  >
export type EmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsQueryResult<
  TData = EmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsKey =
  'EmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisors'
export const UseEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsKey,
    ...(queryKey ?? []),
  ]
export type InsightsServiceInsightsControllerGetInsightsDefaultResponse =
  Awaited<ReturnType<typeof InsightsService.insightsControllerGetInsights>>
export type InsightsServiceInsightsControllerGetInsightsQueryResult<
  TData = InsightsServiceInsightsControllerGetInsightsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useInsightsServiceInsightsControllerGetInsightsKey =
  'InsightsServiceInsightsControllerGetInsights'
export const UseInsightsServiceInsightsControllerGetInsightsKeyFn = (
  {
    page,
  }: {
    page: 'ACTION_PLAN' | 'BUDGET' | 'NET_WORTH' | 'DASHBOARD'
  },
  queryKey?: Array<unknown>,
) => [
  useInsightsServiceInsightsControllerGetInsightsKey,
  ...(queryKey ?? [{ page }]),
]
export type AppointmentsServiceAppointmentsControllerGetAppointmentsDefaultResponse =
  Awaited<
    ReturnType<typeof AppointmentsService.appointmentsControllerGetAppointments>
  >
export type AppointmentsServiceAppointmentsControllerGetAppointmentsQueryResult<
  TData = AppointmentsServiceAppointmentsControllerGetAppointmentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useAppointmentsServiceAppointmentsControllerGetAppointmentsKey =
  'AppointmentsServiceAppointmentsControllerGetAppointments'
export const UseAppointmentsServiceAppointmentsControllerGetAppointmentsKeyFn =
  (
    {
      limit,
      sort,
      userId,
    }: {
      limit?: number
      sort?: unknown
      userId?: number
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAppointmentsServiceAppointmentsControllerGetAppointmentsKey,
    ...(queryKey ?? [{ limit, sort, userId }]),
  ]
export type SupportServiceSupportControllerSearchDefaultResponse = Awaited<
  ReturnType<typeof SupportService.supportControllerSearch>
>
export type SupportServiceSupportControllerSearchQueryResult<
  TData = SupportServiceSupportControllerSearchDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useSupportServiceSupportControllerSearchKey =
  'SupportServiceSupportControllerSearch'
export const UseSupportServiceSupportControllerSearchKeyFn = (
  {
    query,
    type,
  }: {
    query?: string
    type?: 'account' | 'transaction'
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSupportServiceSupportControllerSearchKey,
  ...(queryKey ?? [{ query, type }]),
]
export type EmailNotificationsServiceEmailNotificationsControllerEvaluateDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmailNotificationsService.emailNotificationsControllerEvaluate
    >
  >
export type EmailNotificationsServiceEmailNotificationsControllerEvaluateQueryResult<
  TData = EmailNotificationsServiceEmailNotificationsControllerEvaluateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmailNotificationsServiceEmailNotificationsControllerEvaluateKey =
  'EmailNotificationsServiceEmailNotificationsControllerEvaluate'
export const UseEmailNotificationsServiceEmailNotificationsControllerEvaluateKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmailNotificationsServiceEmailNotificationsControllerEvaluateKey,
    ...(queryKey ?? []),
  ]
export type EmailNotificationsServiceEmailNotificationsControllerDispatchDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmailNotificationsService.emailNotificationsControllerDispatch
    >
  >
export type EmailNotificationsServiceEmailNotificationsControllerDispatchQueryResult<
  TData = EmailNotificationsServiceEmailNotificationsControllerDispatchDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmailNotificationsServiceEmailNotificationsControllerDispatchKey =
  'EmailNotificationsServiceEmailNotificationsControllerDispatch'
export const UseEmailNotificationsServiceEmailNotificationsControllerDispatchKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmailNotificationsServiceEmailNotificationsControllerDispatchKey,
    ...(queryKey ?? []),
  ]
export type EmailNotificationsServiceEmailNotificationsControllerBaselineDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmailNotificationsService.emailNotificationsControllerBaseline
    >
  >
export type EmailNotificationsServiceEmailNotificationsControllerBaselineQueryResult<
  TData = EmailNotificationsServiceEmailNotificationsControllerBaselineDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmailNotificationsServiceEmailNotificationsControllerBaselineKey =
  'EmailNotificationsServiceEmailNotificationsControllerBaseline'
export const UseEmailNotificationsServiceEmailNotificationsControllerBaselineKeyFn =
  (queryKey?: Array<unknown>) => [
    useEmailNotificationsServiceEmailNotificationsControllerBaselineKey,
    ...(queryKey ?? []),
  ]
export type EmailPreviewServiceEmailPreviewControllerSendDefaultResponse =
  Awaited<ReturnType<typeof EmailPreviewService.emailPreviewControllerSend>>
export type EmailPreviewServiceEmailPreviewControllerSendQueryResult<
  TData = EmailPreviewServiceEmailPreviewControllerSendDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>
export const useEmailPreviewServiceEmailPreviewControllerSendKey =
  'EmailPreviewServiceEmailPreviewControllerSend'
export const UseEmailPreviewServiceEmailPreviewControllerSendKeyFn = (
  {
    key,
  }: {
    key?: string
  } = {},
  queryKey?: Array<unknown>,
) => [
  useEmailPreviewServiceEmailPreviewControllerSendKey,
  ...(queryKey ?? [{ key }]),
]
export type UserServiceUserControllerEditProfileMutationResult = Awaited<
  ReturnType<typeof UserService.userControllerEditProfile>
>
export type BankingServiceBankingControllerCreateLinkTokenMutationResult =
  Awaited<ReturnType<typeof BankingService.bankingControllerCreateLinkToken>>
export type BankingServiceBankingControllerCreateAccountsMutationResult =
  Awaited<ReturnType<typeof BankingService.bankingControllerCreateAccounts>>
export type BankingServiceBankingControllerCreateManualAccountMutationResult =
  Awaited<
    ReturnType<typeof BankingService.bankingControllerCreateManualAccount>
  >
export type GoalsServiceGoalsControllerAddMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerAdd>
>
export type GoalsServiceGoalsControllerClaimAmountMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerClaimAmount>
>
export type GoalsServiceGoalsControllerCompleteMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerComplete>
>
export type GoalsServiceGoalsControllerArchiveMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerArchive>
>
export type GoalsServiceGoalsControllerReactivateMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerReactivate>
>
export type GoalsServiceGoalsControllerAddStepMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerAddStep>
>
export type GoalsServiceGoalsControllerToggleStepMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerToggleStep>
>
export type FileServiceFileControllerGetPresignedUrlMutationResult = Awaited<
  ReturnType<typeof FileService.fileControllerGetPresignedUrl>
>
export type BudgetServiceBudgetControllerAddBudgetMutationResult = Awaited<
  ReturnType<typeof BudgetService.budgetControllerAddBudget>
>
export type RolanWealthServiceAuthControllerRegisterMutationResult = Awaited<
  ReturnType<typeof RolanWealthService.authControllerRegister>
>
export type RolanWealthServiceAuthControllerLoginMutationResult = Awaited<
  ReturnType<typeof RolanWealthService.authControllerLogin>
>
export type RolanWealthServiceAuthControllerLogoutMutationResult = Awaited<
  ReturnType<typeof RolanWealthService.authControllerLogout>
>
export type OnboardingServiceOnboardingControllerOnboardingMutationResult =
  Awaited<ReturnType<typeof OnboardingService.onboardingControllerOnboarding>>
export type AdvisorServiceAdvisorControllerGrantAccessMutationResult = Awaited<
  ReturnType<typeof AdvisorService.advisorControllerGrantAccess>
>
export type AdvisorServiceAdvisorControllerRevokeAccessMutationResult = Awaited<
  ReturnType<typeof AdvisorService.advisorControllerRevokeAccess>
>
export type AdvisorsServiceAdvisorGoalsControllerCreateGoalRecommendationMutationResult =
  Awaited<
    ReturnType<
      typeof AdvisorsService.advisorGoalsControllerCreateGoalRecommendation
    >
  >
export type AdminWhitelistServiceAdminWhitelistControllerAddWhitelistedEmailsMutationResult =
  Awaited<
    ReturnType<
      typeof AdminWhitelistService.adminWhitelistControllerAddWhitelistedEmails
    >
  >
export type AppointmentsServiceAppointmentsControllerCreateAppointmentMutationResult =
  Awaited<
    ReturnType<
      typeof AppointmentsService.appointmentsControllerCreateAppointment
    >
  >
export type AppointmentsServiceAppointmentsControllerWebhookMutationResult =
  Awaited<ReturnType<typeof AppointmentsService.appointmentsControllerWebhook>>
export type SupportServiceSupportControllerCreateTicketMutationResult = Awaited<
  ReturnType<typeof SupportService.supportControllerCreateTicket>
>
export type UserServiceUserControllerChangePasswordMutationResult = Awaited<
  ReturnType<typeof UserService.userControllerChangePassword>
>
export type MessageServiceMessageControllerMarkThreadReadMutationResult =
  Awaited<ReturnType<typeof MessageService.messageControllerMarkThreadRead>>
export type TransactionServiceTransactionControllerBulkEditTransactionsMutationResult =
  Awaited<
    ReturnType<
      typeof TransactionService.transactionControllerBulkEditTransactions
    >
  >
export type TransactionServiceTransactionControllerToggleExcludedMutationResult =
  Awaited<
    ReturnType<typeof TransactionService.transactionControllerToggleExcluded>
  >
export type TransactionServiceTransactionControllerEditTransactionMutationResult =
  Awaited<
    ReturnType<typeof TransactionService.transactionControllerEditTransaction>
  >
export type BankingServiceBankingControllerEditManualAccountMutationResult =
  Awaited<ReturnType<typeof BankingService.bankingControllerEditManualAccount>>
export type GoalsServiceGoalsControllerUpdateMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerUpdate>
>
export type GoalsServiceGoalsControllerAcceptRecommendationMutationResult =
  Awaited<ReturnType<typeof GoalsService.goalsControllerAcceptRecommendation>>
export type GoalsServiceGoalsControllerUpdateStepMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerUpdateStep>
>
export type GoalsServiceGoalsControllerReorderStepsMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerReorderSteps>
>
export type NotificationsServiceNotificationControllerMarkAsReadMutationResult =
  Awaited<
    ReturnType<typeof NotificationsService.notificationControllerMarkAsRead>
  >
export type BudgetServiceBudgetControllerUpdateBudgetMutationResult = Awaited<
  ReturnType<typeof BudgetService.budgetControllerUpdateBudget>
>
export type RolanWealthServiceAuthControllerResetPasswordMutationResult =
  Awaited<ReturnType<typeof RolanWealthService.authControllerResetPassword>>
export type RolanWealthServiceVerifyControllerVerifyEmailMutationResult =
  Awaited<ReturnType<typeof RolanWealthService.verifyControllerVerifyEmail>>
export type RolanWealthServiceVerifyControllerVerifyResetPasswordTokenMutationResult =
  Awaited<
    ReturnType<
      typeof RolanWealthService.verifyControllerVerifyResetPasswordToken
    >
  >
export type OnboardingServiceOnboardingControllerUpdateAnswersMutationResult =
  Awaited<
    ReturnType<typeof OnboardingService.onboardingControllerUpdateAnswers>
  >
export type AdminUsersServiceAdminUsersControllerVerifyUserMutationResult =
  Awaited<ReturnType<typeof AdminUsersService.adminUsersControllerVerifyUser>>
export type EmployerUsersServiceEmployerUsersControllerChangeRoleMutationResult =
  Awaited<
    ReturnType<typeof EmployerUsersService.employerUsersControllerChangeRole>
  >
export type UserServiceUserControllerDeleteUserMutationResult = Awaited<
  ReturnType<typeof UserService.userControllerDeleteUser>
>
export type BankingServiceBankingControllerDeleteManualAccountMutationResult =
  Awaited<
    ReturnType<typeof BankingService.bankingControllerDeleteManualAccount>
  >
export type BankingServiceBankingControllerDeleteAccountMutationResult =
  Awaited<ReturnType<typeof BankingService.bankingControllerDeleteAccount>>
export type GoalsServiceGoalsControllerDeleteMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerDelete>
>
export type GoalsServiceGoalsControllerRejectRecommendationMutationResult =
  Awaited<ReturnType<typeof GoalsService.goalsControllerRejectRecommendation>>
export type GoalsServiceGoalsControllerDeleteStepMutationResult = Awaited<
  ReturnType<typeof GoalsService.goalsControllerDeleteStep>
>
export type BudgetServiceBudgetControllerDeleteBudgetMutationResult = Awaited<
  ReturnType<typeof BudgetService.budgetControllerDeleteBudget>
>
export type AdminWhitelistServiceAdminWhitelistControllerDeleteWhitelistedEmailsMutationResult =
  Awaited<
    ReturnType<
      typeof AdminWhitelistService.adminWhitelistControllerDeleteWhitelistedEmails
    >
  >
export type EmployerUsersServiceEmployerUsersControllerDeleteEmployeeMutationResult =
  Awaited<
    ReturnType<
      typeof EmployerUsersService.employerUsersControllerDeleteEmployee
    >
  >
